import * as ft from 'focus-trap'

class MarketSiteDrawer {
    constructor() {
        if (MarketSiteDrawer.instance) {
            return MarketSiteDrawer.instance
        }

        MarketSiteDrawer.instance = this

        this.focusTrap = ft.createFocusTrap(this.drawer, {})
        this.bindEvents()
    }

    get openButtons() {
        return document.querySelectorAll('[data-market-site-switch-toggle]')
    }

    get closeButton() {
        return document.querySelector('[data-market-site-switch-close]')
    }

    get drawer() {
        return document.getElementById('market-site-switch')
    }

    get overlay() {
        return document.getElementById('market-site-switch-overlay')
    }

    bindEvents() {
        if (!this.drawer) return

        this.openButtons.forEach(button => button.addEventListener('click', this.open.bind(this)))
        this.closeButton?.addEventListener('click', this.close.bind(this))
        this.overlay?.addEventListener('click', this.close.bind(this))
        this.drawer?.addEventListener('keydown', (event) => (event.key === 'Escape') && this.close())
    }

    open() {
        if (!this.drawer) return

        this.drawer.removeAttribute('hidden')
        document.documentElement.classList.add('overflow-hidden')
        this.focusTrap.activate()
        this.closeButton.focus()
    }

    close() {
        if (!this.drawer) return

        this.drawer.setAttribute('hidden', '')
        document.documentElement.classList.remove('overflow-hidden')
        this.focusTrap.deactivate()
        this.openButtons[0]?.focus()
    }

    static create() {
        return new MarketSiteDrawer()
    }
}

export default MarketSiteDrawer
